<div
  class="upgrade-plan-blocker-container"
  [class.simple-tooltip]="!isTeacherOrAdmin"
  [@fadeIn]
  [ngClass]="{
    'cml-8': arrow === 'left',
    'cmr-8': arrow === 'right',
    'cmt-8': arrow === 'top',
    'cmb-8': arrow === 'bottom'
  }"
>
  <div class="upgrade-plan-tip">
    <div class="_inner" *ngIf="isTeacherOrAdmin; else simpleTooltip">
      <div class="text-container">
        <div class="header-text">
          {{ 'Start free trial to unlock' | translate }}
        </div>
        <div class="body-text">
          {{ 'Start your 14-day trial to use video calling, recording, and more.' | translate }}
        </div>
      </div>
      <app-pencil-button
        class="pencil-button medium upgrade-btn"
        data-name="upgrade-plan-blocker-proceed"
        (clickEvent)="openStartTrialModal()"
        icon="arrow_circle_up"
        [iconConfig]="{ type: IconTypes.materialIcon }"
        [label]="'Start free trial' | translate"
      >
      </app-pencil-button>
    </div>
    <ng-template #simpleTooltip>
      <div class="simple-text">
        {{ 'This feature is not part of your plan' | translate }}
      </div>
    </ng-template>
  </div>
  <div *ngIf="arrow" [class]="'custom-' + arrow + '-tip-after'"></div>
</div>
